<template>
  <div class="mycenter">
    <Row class="top-title" type="flex" justify="space-between" align="bottom">
      <i-col span="8" class="title-left">
        <span>个人中心</span>
        <router-link to="/mymenu">我的首页</router-link>
      </i-col>
    </Row>
    <Tabs
      size="small"
      style="width: 1275px; margin: 0 auto"
      v-model="activeKeyNum"
      :active-key.sync="activeKey"
    >
      <TabPane label="个人资料">
        <div class="data">
          <Row type="flex" justify="space-between">
            <i-col span="6" class="people">
              <img
                v-if="userInfo.sex == 2"
                src="@/assets/mycenter/girl.png"
                alt
                class="img"
              />
              <img v-else src="@/assets/mycenter/boy.png" alt class="img" />
              <img src="@/assets/mycenter/people-bg.png" alt class="img1" />
              <img src="@/assets/mycenter/u.png" alt class="img2" />
            </i-col>
            <i-col span="18" class="msg">
              <p class="title">
                <span>{{ userInfo.realname }}</span>
                <svg-icon
                  icon-class="edit"
                  style="font-size: 30px; cursor: pointer"
                  @click="edit"
                ></svg-icon>
                <Divider type="vertical" />
                <span>
                  <Poptip
                    v-if="userDetail.wechatInfo == null"
                    placement="bottom"
                    width="240"
                    height="300"
                    :title="'微信扫码绑定'"
                  >
                    <span>绑定微信</span>
                    <div class="bind-wechat" slot="content">
                      <qrcode-vue
                        :value="bindWechat()"
                        :size="200"
                        level="H"
                      ></qrcode-vue>
                    </div>
                  </Poptip>
                  <Poptip
                    v-if="userDetail.wechatInfo != null"
                    confirm
                    title="确定要解绑微信吗？"
                    @on-ok="unbindWechat"
                    style="color: black"
                  >
                    <span style="color: white">解绑微信</span>
                  </Poptip>
                  <!-- <span v-if="userDetail.wechatInfo == null" @click="bindWechat">绑定微信</span> -->
                  <!-- <span v-if="userDetail.wechatInfo != null" @click="unbindWechat">解绑微信</span> -->
                  <i class="fa fa-wechat"></i>
                </span>
              </p>
              <p class="sign">{{ userInfo.sign }}</p>
              <div class="progress">
                <Progress :percent="25" style="width: 235px" />
                <span>LV 1</span>
                <svg-icon icon-class="sd" style="font-size: 20px"></svg-icon>
                <span class="green">{{ userInfo.integral }}</span>
                积fun
              </div>
              <Row type="flex" align="middle">
                <i-col
                  span="4"
                  class="msg-item"
                  @click="activeKey = 'mineAward'"
                >
                  <div @click="toTab(3)">
                    <div>
                      <img src="@/assets/mycenter/jx.jpg" alt />
                    </div>
                    <p>我的奖项</p>
                    <p>{{ userCountInfo.honorCount }}</p>
                  </div>
                </i-col>
                <i-col span="4" class="msg-item">
                  <div @click="toTab(4)">
                    <div>
                      <svg-icon icon-class="xx"></svg-icon>
                    </div>
                    <p>收藏</p>
                    <p>{{ userCountInfo.favCount }}</p>
                  </div>
                </i-col>
                <i-col v-if="false" span="4" class="msg-item">
                  <div>
                    <img src="@/assets/mycenter/team.jpg" alt />
                  </div>
                  <p>我的团队</p>
                  <p>{{ userCountInfo.teamCount }}</p>
                </i-col>
                <i-col span="4" class="msg-item">
                  <div @click="toTab(2)">
                    <div>
                      <svg-icon icon-class="num"></svg-icon>
                    </div>
                    <p>我的代码量</p>
                    <p>{{ userCountInfo.codeCount }}</p>
                  </div>
                </i-col>
                <i-col span="4" class="msg-item">
                  <div @click="toTab(1)">
                    <div>
                      <img src="@/assets/mycenter/work.jpg" alt />
                    </div>
                    <p>我的作品</p>
                    <p>{{ userCountInfo.workTotal }}</p>
                  </div>
                </i-col>
              </Row>
              <Row type="flex" style="margin-top: 40px">
                <i-col span="4" class="tip-item">
                  <Tooltip
                    :content="
                      '共参加' +
                      userCountInfo.scratchCourseMine +
                      '个图形化编程课程'
                    "
                    theme="light"
                  >
                    <div @mouseover="isShowIndex = 0">
                      <img src="@/assets/mycenter/t1.jpg" alt />
                    </div>
                    <div
                      class="percent"
                      v-show="isShowIndex === 0"
                      @mouseleave="isShowIndex = ''"
                    >
                      0%
                    </div>
                  </Tooltip>
                  <p>积木编程</p>
                </i-col>
                <i-col span="4" class="tip-item">
                  <Tooltip
                    :content="
                      '共参加' + userCountInfo.gameCourseMine + '个游戏设计课程'
                    "
                    theme="light"
                  >
                    <div @mouseover="isShowIndex = 1">
                      <img src="@/assets/mycenter/t2.jpg" alt />
                    </div>
                    <div
                      class="percent"
                      v-show="isShowIndex === 1"
                      @mouseleave="isShowIndex = ''"
                    >
                      0%
                    </div>
                  </Tooltip>
                  <p>游戏设计</p>
                </i-col>
                <i-col span="4" class="tip-item">
                  <Tooltip
                    :content="
                      '共参加' +
                      userCountInfo.textCourseMine +
                      '个文本类编程课程'
                    "
                    theme="light"
                  >
                    <div @mouseover="isShowIndex = 2">
                      <img src="@/assets/mycenter/t3.jpg" alt />
                    </div>
                    <div
                      class="percent"
                      v-show="isShowIndex === 2"
                      @mouseleave="isShowIndex = ''"
                    >
                      0%
                    </div>
                  </Tooltip>
                  <p>文本类编程</p>
                </i-col>
                <i-col span="4" class="tip-item">
                  <Tooltip
                    :content="
                      '共参加' + userCountInfo.aiCourseMine + '个人工智能课程'
                    "
                    theme="light"
                  >
                    <div @mouseover="isShowIndex = 3">
                      <img src="@/assets/mycenter/t4.jpg" alt />
                    </div>

                    <div
                      class="percent"
                      v-show="isShowIndex === 3"
                      @mouseleave="isShowIndex = ''"
                    >
                      0%
                    </div>
                  </Tooltip>
                  <p>人工智能</p>
                </i-col>
                <i-col span="4" class="tip-item">
                  <Tooltip
                    :content="
                      '共参加' + userCountInfo.robotCourseMine + '个机器人课程'
                    "
                    theme="light"
                  >
                    <div @mouseover="isShowIndex = 4">
                      <img src="@/assets/mycenter/t5.jpg" alt />
                    </div>

                    <div
                      class="percent"
                      v-show="isShowIndex === 4"
                      @mouseleave="isShowIndex = ''"
                    >
                      0%
                    </div>
                  </Tooltip>
                  <p>机器人</p>
                </i-col>
              </Row>
            </i-col>
          </Row>
        </div>
      </TabPane>
      <TabPane label="我的作品" key="mineWork">
        <Row type="flex" justify="space-between" class="my-work">
          <i-col>
            <Select
              class="select"
              value
              size="small"
              style="width: 150px"
              @on-change="getMineWork()"
              v-model="workParam.orderBy"
            >
              <Option value>全部</Option>
              <Option value="view_num">最热</Option>
              <Option value="comment_num">评论</Option>
              <Option value="star_num">点赞</Option>
            </Select>
          </i-col>
          <i-col>
            <Select
              class="select"
              value
              size="small"
              @on-change="getMineWork()"
              v-model="workParam.workStatus"
              style="width: 150px"
            >
              <Option value>全部状态</Option>
              <Option value="0">未发布</Option>
              <Option value="1">已发布</Option>
            </Select>
          </i-col>
          <i-col>
            <Select
              class="select"
              value="111"
              size="small"
              style="width: 150px"
            >
              <Option value="111">全部分类</Option>
              <Option value="1">scratch</Option>
            </Select>
          </i-col>
          <i-col>
            <Select
              class="select"
              value="111"
              size="small"
              @on-change="getMineWork()"
              v-model="workParam.timeRange"
              style="width: 150px"
            >
              <Option value>全部时间</Option>
              <Option value="year">今年发布</Option>
              <Option value="month">最近一月</Option>
              <Option value="week">最近一周</Option>
              <Option value="day">最近一天</Option>
            </Select>
          </i-col>
          <i-col>
            <Input
              search
              class="search"
              v-model="workParam.workName"
              @on-change="getMineWork()"
              placeholder="请输入搜索内容"
            />
          </i-col>
        </Row>
        <Row class="course-list">
          <i-col
            span="5"
            class="course-item"
            v-for="(item, index) in mineWorkResult.records"
            :key="index"
          >
            <card :bordered="false">
              <img :src="getCoverFileUrl(item)" @click="toDetail(item)" alt />
              <p class="title" @click="toDetail(item)">
                {{ item.workName }}
              </p>
              <p>
                <b>{{ item.workType_dictText }}</b>
                <i class="fa fa-thumbs-up"></i>
                {{ item.starNum }}
                <i class="fa fa-comment-o"></i>
                {{ item.commentNum }}
                <i class="fa fa-eye"></i>
                {{ item.viewNum }}
              </p>
              <div class="footer-content">
                <b class="fa fa-user q"></b>
                {{ item.realname }}
              </div>
              <span>初学者</span>
            </card>
          </i-col>
        </Row>
      </TabPane>
      <!-- <TabPane label="我的团队" key="mineTeam"></TabPane> -->
      <TabPane label="我的代码量" key="mineCode">
        <div class="data" style="color: white; text-align: left">
          <div>
            <h1>Scratch</h1>
            <p>您已完成了{{ userCountInfo.codeCount }}个积木</p>
          </div>
          <br />
          <div>
            <h1>Python</h1>
            <p>还没有任何代码哦，继续努力！</p>
          </div>
        </div>
      </TabPane>
      <TabPane label="我的奖项" key="mineAward">
        <div class="data" style="color: white;t">
          <Row type="flex">
            <i-col span="4" style="background: #9078c6">
              <br />
              <img src="@/assets/mycenter/cup.png" alt style="width: 100px" />
              <p>奖杯</p>
              <p>
                {{ mineAward.filter((x) => x.grantCount > 0).length }}之{{
                  mineAward.length
                }}
              </p>
              <Progress :percent="25" style="width: 150px" hide-info />
              <br />
            </i-col>
            <i-col span="20" style="background: #25293a">
              <Row type="flex">
                <i-col
                  span="4"
                  v-for="(item, index) in mineAward"
                  :key="index"
                  style="margin-top: 20px"
                >
                  <img
                    style="max-width: 80px; min-height: 80px"
                    :class="item.grantCount > 0 ? '' : 'gray'"
                    :src="item.awardCoverUrl"
                    alt
                  />
                  <p>{{ item.awardName }}</p>
                </i-col>
              </Row>
            </i-col>
          </Row>
        </div>
      </TabPane>
      <TabPane label="我的收藏" key="mineCollect">
        <Row class="course-list">
          <i-col
            span="5"
            class="course-item"
            v-for="(item, index) in collectWorkResult.records"
            :key="index"
          >
            <card :bordered="false">
              <img :src="getCoverFileUrl(item)" @click="toDetail(item)" alt />
              <p class="title" @click="toDetail(item)">
                {{ item.workName }}
              </p>
              <p>
                <b>{{ item.workType_dictText }}</b>
                <i class="fa fa-thumbs-up"></i>
                {{ item.starNum }}
                <i class="fa fa-comment-o"></i>
                {{ item.commentNum }}
                <i class="fa fa-eye"></i>
                {{ item.viewNum }}
              </p>
              <div class="footer-content" @click="toFriend(item.userId)">
                <b class="fa fa-user q" @click="toFriend(item.userId)"></b>
                {{ item.realname }}
                <!-- <div @click="toFriend(item.userId)">{{item.realname}}</div> -->
              </div>
              <span>初学者</span>
            </card>
          </i-col>
        </Row>
      </TabPane>
    </Tabs>
    <Modal
      v-model="isShowEdit"
      class="mycourse-edit-modal"
      @on-ok="editUserInfo"
    >
      <div class="edit-btn">编辑信息</div>
      <Form :model="userInfo" label-position="left" :label-width="80">
        <FormItem label="昵称">
          <i-input
            v-model="updateUserInfo.realname"
            placeholder="请输入用户名称"
            :maxlength="11"
          ></i-input>
        </FormItem>
        <FormItem label="性别">
          <RadioGroup v-model="updateUserInfo.sex">
            <Radio :label="2">女</Radio>
            <Radio :label="1">男</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="个性签名">
          <i-input
            v-model="updateUserInfo.sign"
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 8 }"
            placeholder="请输入介绍信息"
          ></i-input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { register, login, logout, updateUserInfo } from "@/api";
import { setToken, setUserInfo } from "@/utils/auth";
import { mineAward } from "@/api/user";
import { removeToken, getToken, removeUserInfo } from "@/utils/auth";
import {
  getUserDetail,
  userCountInfo,
  getUserInfo,
  unbindWechat,
} from "@/api/user";
import { getMineWork, collectWorkList } from "@/api/community";
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    QrcodeVue,
  },
  data() {
    return {
      activeKey: "mineWork", // profile mineWork mineCode mineAward mineCollect
      activeKeyNum: 0,
      type: "",
      isShowIndex: "",
      isShowEdit: false,
      formLeft: {},
      userDetail: {
        userInfo: {},
        wechatInfo: {},
      },
      userInfo: {},
      userCountInfo: {},
      mineWorkResult: {},
      mineAward: [],
      collectWorkResult: {},
      workParam: {
        orderBy: "update_time",
        isAsc: false,
        timeRange: "",
        workStatus: null,
        workName: "",
        pageSize: 999,
        pageNo: 1,
      },
      updateUserInfo: {
        id: "",
        realname: "",
        sex: "",
        sign: "",
      },
    };
  },
  mounted() {
    this.getUserDetail();
    // this.getUserInfo();
    var that = this;
  },
  watch: {
    activeKeyNum(val, old) {
      this.mineWorkResult = {};
      this.collectWorkResult = {};
      if (val == 1) {
        this.getMineWork();
      }else if(val == 4){
        this.getMineCollectWork()
      }

    },
  },
  methods: {
    logout() {
      logout().then((res) => {
        console.log(res);
        if (res.code === 200) {
          removeToken();
          removeUserInfo();
          this.$Message.success(res.message);
          setTimeout(() => {
            this.$router.replace("/home");
          }, 1000);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    edit() {
      this.isShowEdit = true;
      this.updateUserInfo = {};
      this.updateUserInfo.id = this.userInfo.id;
      this.updateUserInfo.realname = this.userInfo.realname;
      this.updateUserInfo.sex = this.userInfo.sex;
      this.updateUserInfo.sign = this.userInfo.sign;
    },
    editUserInfo() {
      updateUserInfo(this.updateUserInfo).then((res) => {
        if (res.code === 200) {
          this.$Message.success(res.message);
          this.getUserInfo();
        } else {
          this.$Message.info(res.message);
        }
      });
    },
    getUserInfo() {
      getUserInfo().then((res) => {
        if (res.success) {
          this.userInfo = res.result;
          this.getUserCountInfo();
          // this.getMineWork();
          // this.getMineCollectWork();
        }
      });
    },
    getUserDetail() {
      getUserDetail().then((res) => {
        if (res.success) {
          this.userDetail = res.result;
          this.userInfo = res.result.userInfo;
          if (
            (this.userInfo.phone == null || this.userInfo.phone == "") &&
            this.userInfo.loginTimes > 4
          ) {
            this.$Message.error(
              "登录已经超过5次了，需要绑定手机才可以继续使用账户"
            );
            this.bindPhoneMode = 2;
            this.isShowBindPhone = true;
          }
          this.getUserCountInfo();
          // this.getMineWork();
          this.getMineCollectWork();
          this.getMineAward();
        }
      });
    },
    getUserCountInfo() {
      userCountInfo().then((res) => {
        if (res.success) {
          this.userCountInfo = res.result;
        }
      });
    },
    getMineAward() {
      mineAward().then((res) => {
        this.mineAward = res.result;
      });
    },
    getMineWork() {
      // userId, orderBy, isAsc, timeRange, workStatus, workName, pageSize, pageNo
      getMineWork(
        this.userInfo.id,
        this.workParam.orderBy,
        this.workParam.isAsc,
        this.workParam.timeRange,
        this.workParam.workStatus,
        this.workParam.workName,
        this.workParam.pageSize,
        this.workParam.pageNo
      ).then((res) => {
        if (res.success) {
          this.mineWorkResult = res.result;
        }
      });
    },
    getMineCollectWork() {
      collectWorkList(this.userInfo.id).then((res) => {
        if (res.success) {
          this.collectWorkResult = res.result;
        }
      });
    },
    bindWechat() {
      return (
        "http://www.vcode.fun/api/wechatAuth/wechatLogin?redirectUrl=/static/wechat/bind.html?token=" +
        getToken()
      );
    },
    unbindWechat() {
      unbindWechat().then((res) => {
        this.$Message.success(res.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
    },
    toDetail(work) {
      if (work.workType == "2") {
        this.$router.push({
          path: `/task-detail?workId=${work.id}`,
        });
      } else {
        window.open(work.workFileUrl)
      }
    },
    getCoverFileUrl(work){
      if(work.coverFileUrl == null){
        if(work.workFileUrl.includes(".jpg") ||
          work.workFileUrl.includes(".png") ||
          work.workFileUrl.includes(".jpeg") ||
          work.workFileUrl.includes(".gif") ||
          work.workFileUrl.includes(".svg")){
            
        }
        return "/static/img/file.jpg"
      }else{
        return work.coverFileUrl;
      }
    },
    toFriend(userId) {
      this.$router.push({
        path: `/friends?userId=${userId}`,
      });
    },
    toTab(index) {
      document.querySelectorAll(".ivu-tabs-tab")[index].click();
    },
  },
};
</script>
<style lang="scss">
.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
.mycenter {
  .ivu-tabs-bar {
    border: none;
  }
  .ivu-tabs-ink-bar {
    display: none;
  }
  .ivu-tabs-tab {
    width: 200px;
    height: 80px;
    color: #fff;
    font-weight: 700;
    font-size: 20px !important;
    line-height: 50px;
    &:hover {
      color: unset;
    }
  }
  .ivu-tabs-nav .ivu-tabs-tab-active {
    background-image: url("../../assets/mycourse/u1807.png"),
      url("../../assets/mycourse/u1806.png");
    background-size: 67px 61px, 200px 45px;
    background-repeat: no-repeat, no-repeat;
    background-position: 0 0, 15px 10px;
    color: #333;
    font-size: 16px !important;
  }
  .progress {
    .ivu-progress-bg {
      background: #fbe309;
    }
    .ivu-progress-text {
      display: none;
    }
  }

  .ivu-select-visible .ivu-select-selection,
  .ivu-select-selection-focused,
  .ivu-select-selection:hover {
    border-color: #fff;
  }
  .ivu-tooltip {
    width: 100%;
  }
  .course-list .course-item .ivu-card-body {
    padding: 0;
  }
}
.mycourse-edit-modal {
  color: #fff;
  .ivu-modal-content {
    background: linear-gradient(
      61.4deg,
      rgba(17, 143, 151, 1) 7%,
      rgba(37, 170, 130, 1) 100%
    );
    border-radius: 20px;
  }
  .ivu-form .ivu-form-item-label {
    color: #fff;
  }
  .ivu-modal-body {
    padding: 60px 80px 20px 80px;
  }
  .ivu-modal-close .ivu-icon {
    background: #fff;
    color: #000;
    border-radius: 50%;
    font-weight: 700;
  }
}
</style>
<style lang="scss" scoped>
.mycenter {
  width: 1280px;
  margin: 0 auto;
  padding-bottom: 80px;
  .top-title {
    width: 1360px;
    margin: 40px auto;
    .title-left {
      color: #fff;
      span {
        font-weight: 700;
        margin-right: 50px;
        font-size: 30px;
      }
      a {
        font-weight: 700;
        font-size: 20px;
        background: rgb(57, 165, 239);
        display: inline-block;
        border-radius: 30px;
        line-height: 30px;
        padding: 5px 36px;
      }
    }
    .title-right {
      font-size: 20px;
      color: #192648;
      border-radius: 30px;
      background: #fff;
      line-height: 40px;
      padding: 0px 36px;
      height: 40px;
      cursor: pointer;
      &:hover {
        background: #f5c54a;
        color: #fff;
      }
    }
  }
  .data {
    height: 670px;
    background-color: rgba(32, 108, 78, 0.4);
    border: 1px solid rgba(121, 121, 121, 1);
    border-radius: 20px;
    padding: 60px 30px;
    .people {
      z-index: 0;
      position: relative;
      padding-top: 40px;
      img {
        &.img {
          position: absolute;
          left: -30px;
          top: 36px;
          z-index: 100;
          width: 367px;
        }
        &.img1 {
          position: absolute;
          left: -80px;
          top: -30px;
          z-index: 99;
          width: 460px;
          opacity: 0.5;
          height: 412px;
        }
        &.img2 {
          position: absolute;
          left: 18px;
          top: 308px;
          width: 276px;
        }
      }
    }
    .msg {
      color: #fff;
      text-align: left;
      font-weight: 700;
      padding-top: 66px;
      .title {
        span {
          font-size: 25px;
          margin-right: 40px;
        }
      }
      .progress {
        font-size: 16px;
        margin: 30px 0;
        .green {
          color: #f59a23;
        }
      }
      .msg-item {
        width: 149px;
        height: 133px;
        border-radius: 5px;
        padding: 20px;
        text-align: center;
        background-color: rgba(255, 255, 255, 0.3);
        margin-right: 30px;
        &:last-child {
          margin-right: 0;
        }
        div {
          height: 40px;
          .svg-icon {
            font-size: 38px;
          }
        }
        p {
          margin-top: 5px;
        }
      }
      .tip-item {
        text-align: center;
        line-height: 110px;
        background: #5fcaca;
        border-radius: 50%;
        width: 118px;
        height: 118px;
        border: 15px solid #fef5a2;
        margin-right: 68px;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        .percent {
          background: rgba(0, 0, 0, 0.4);
          position: absolute;
          top: -16px;
          right: -16px;
          width: 120px;
          height: 120px;
          border: 15px solid #fef5a2;
          border-radius: 50%;
          line-height: 88px;
        }
        p {
          line-height: 3;
        }
      }
    }
  }

  .course-list {
    margin-top: 30px;
    font-size: 0;
    .course-item {
      width: 292px;
      margin-right: 25px;
      margin-bottom: 30px;
      position: relative;
      img {
        // width: 100%;
        height: 159px;
        border-radius: 4px;
      }
      p {
        color: #999;
        text-align: left;
        padding: 5px 20px 10px;
        font-size: 12px;
        &.title {
          color: #333;
          font-size: 18px;
          font-weight: 700;
        }
        font-size: 14px;
        b {
          font-weight: 400;
          margin-right: 30px;
        }
      }
      .footer-content {
        color: #999;
        font-size: 12px;
        height: 50px;
        border-top: 1px solid #e7e7e7;
        line-height: 50px;
        text-align: left;
        padding: 0 18px;
        b {
          color: #fff;
          padding: 5px 4px 5px 8px;
          margin-right: 13px;
          background: #ccc;
          text-align: center;
          border-radius: 50%;
        }
      }
      span {
        position: absolute;
        top: 121px;
        right: 20px;
        color: #fff;
        background: rgba(109, 202, 157, 1);
        font-size: 12px;
        padding: 2px 20px;
        border-radius: 3px;
      }
    }
  }
}
.mycourse-edit-modal {
  position: relative;
  .edit-btn {
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgb(30, 133, 140);
    width: 208px;
    height: 52px;
    line-height: 52px;
    text-align: center;
    border: 1px solid #22a685;
    border-radius: 52px;
    font-size: 20px;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/my/mycenter.vue